import { configureStore } from '@reduxjs/toolkit';

import langReducer from '@/configuration/lang/langSlice';
import loginReducer from '@/configuration/login/loginSlice';
import tokenReducer from '@/configuration/tokenHandling/tokenSlice';
import appReducer from '@/features/app/appSlice';
import configReducer from './configSlice';

export const store = configureStore({
    reducer: {
        config: configReducer,
        lang: langReducer,
        app: appReducer,
        login: loginReducer,
        tokenHandling: tokenReducer,
    },
    // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(...),
});

// Infer the `RootState` and `RootDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type RootDispatch = typeof store.dispatch;
